var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        [
          _c(_vm.component, {
            tag: "component",
            attrs: { evalTask: _vm.evalTask },
            on: {
              "update:evalTask": function ($event) {
                _vm.evalTask = $event
              },
              "update:eval-task": function ($event) {
                _vm.evalTask = $event
              },
            },
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }